// avatarColor.ts — цвет аватара по id (детерминированно, oklch, темизируемо)
// Хэш id → один из 8 премиум oklch акцентов, адаптируется под тему (светлая/тёмная).

const PALETTE_LIGHT = [
  'oklch(0.62 0.18 25)',  // coral
  'oklch(0.65 0.16 145)', // mint
  'oklch(0.62 0.17 250)', // blue
  'oklch(0.68 0.15 75)',  // amber
  'oklch(0.60 0.16 310)', // violet
  'oklch(0.65 0.14 190)', // cyan
  'oklch(0.62 0.15 10)',  // red
  'oklch(0.66 0.12 95)',  // olive
];
const PALETTE_DARK = [
  'oklch(0.68 0.14 25)',
  'oklch(0.70 0.13 145)',
  'oklch(0.70 0.12 250)',
  'oklch(0.72 0.13 75)',
  'oklch(0.68 0.14 310)',
  'oklch(0.70 0.12 190)',
  'oklch(0.68 0.14 10)',
  'oklch(0.70 0.11 95)',
];

function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function avatarColor(id: string, isDark: boolean): string {
  const pal = isDark ? PALETTE_DARK : PALETTE_LIGHT;
  return pal[hashStr(id) % pal.length];
}

export function avatarBg(id: string, isDark: boolean): string {
  // Полупрозрачный фон + бордер того же oklch
  const c = avatarColor(id, isDark);
  return `color-mix(in oklch, ${c} 18%, transparent)`;
}
export function avatarFg(id: string, isDark: boolean): string {
  return avatarColor(id, isDark);
}
